import React, { useState } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import "../../../../assets/styles/custom.css";
import { IconContext } from "react-icons";
import MenuIcon from "@material-ui/icons/Menu";
import { useHistory } from "react-router";

function Navbar() {
  const history = useHistory();
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);

  const dash = window.location.pathname.includes("/home/dashboard");
  const users = window.location.pathname.includes("/home/users");
  const terms = window.location.pathname.includes("/home/terms");

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <div className="navbar-tab">
          <Link to="#" className="menu-bars">
            <MenuIcon style={{ color: "#001441" }} onClick={showSidebar} />
          </Link>
        </div>

        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-menu-items" onClick={showSidebar}>
            <li className={dash ? "nav-text" : "nav-Nonselected-text"}>
              <img
                onClick={() => history.push("/home/dashboard")}
                src="/images/Dashboard.svg"
                alt=""
              />
              <span onClick={() => history.push("/home/dashboard")}>
                {" "}
                Dashboard{" "}
              </span>
            </li>

            <li className={users ? "nav-text" : "nav-Nonselected-text"}>
              <img
                onClick={() => history.push("/home/users")}
                src="/images/user_icon.svg"
                alt=""
              />
              <span onClick={() => history.push("/home/users")}> Users </span>
            </li>

            {/* <li className="nav-Nonselected-text">
              <img src="/images/promotion.svg" alt="" />
              <span onClick={() => history.push("#")}> Campaign </span>
            </li> */}
            <li className={terms ? "nav-text" : "nav-Nonselected-text"}>
              <img
                onClick={() => history.push("/home/terms")}
                src="/images/setting.svg"
                alt=""
              />
              <span onClick={() => history.push("/home/terms")}> Setting </span>
            </li>
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
